import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import PromotionUnlockedChip from 'bento-ordering/promotions/components/PromotionUnlockedChip';
import { MAX_MENU_WIDTH } from 'bento-ordering/base/constants/maxWidth';
import { useMenu } from 'bento-ordering/context/MenuContext';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { WHITE, MEDIUM_SOY, SOY, MEDIUM_TOFU } from 'styles/theme/colors';
import usePromotionById from 'bento-ordering/promotions/hooks/usePromotionById';

const StyledHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '6px 0 8px',
  width: '100%',
  justifyContent: 'space-between',
  marginTop: '28px',
  maxWidth: MAX_MENU_WIDTH,
  borderBottom: `1px solid ${SOY}`
});

function FilteredItemBar() {
  const { filteredPromotion, resetFilteredPromoId } = useMenu();

  const filteredPromotionInfo = usePromotionById(filteredPromotion.id);

  if (!filteredPromotionInfo) {
    resetFilteredPromoId();
  }

  return (
    <>
      <StyledHeader>
        <Chip
          icon={
            <LocalOfferIcon
              sx={{
                fill: WHITE,
                height: '20px',
                width: '20px'
              }}
            />
          }
          label={filteredPromotionInfo?.promotion.abbreviated_promotion_name}
          sx={{
            color: WHITE,
            backgroundColor: MEDIUM_SOY,
            fontSize: 14,
            fontWeight: 450,
            padding: '8px'
          }}
        />
        <Button
          variant="text"
          sx={{ color: MEDIUM_SOY, borderLeft: `1px solid ${MEDIUM_TOFU}` }}
          onClick={() => resetFilteredPromoId()}
        >
          Back to Full Menu
        </Button>
      </StyledHeader>
      <MenuItemDescriptionTypography
        variant={ITEM_DESCRIPTION_AND_PRICES}
        sx={{ display: 'block', margin: '15px 0 10px' }}
      >
        {filteredPromotionInfo?.promotion.description}
      </MenuItemDescriptionTypography>
      {filteredPromotionInfo?.unlocked ? (
        <PromotionUnlockedChip />
      ) : (
        <MenuItemDescriptionTypography
          variant={ITEM_DESCRIPTION_AND_PRICES}
          sx={{ display: 'block' }}
        >
          {filteredPromotionInfo?.promotion_progress_message}
        </MenuItemDescriptionTypography>
      )}
    </>
  );
}

export default FilteredItemBar;
